"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.7792 5.4L12.9708 10.9893L18.2001 18.6H14.354L10.8324 13.475L6.42347 18.6H5.28398L10.3266 12.7388L5.28398 5.4H9.13007L12.4647 10.2531L16.6397 5.4H17.7792ZM14.8901 17.7812H16.6403L8.58422 6.25779H6.83404L14.8901 17.7812Z';